

<script>
export default {
    name: 'registrationBtn',
    data() {
        return {

        };
    },
    methods: {

    }
}
</script>
<template>
    <router-link class="registration-button" to="/login?r=true">Регистрация<img src='../../assets/image/regArrow.svg'></router-link>
</template>
<style scoped>
.registration-button {
    border-radius: 35px;
    background: #E7ECEE;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    width: 204px;
    height: 60px;
    color: #1E1F22;
    text-align: center;
    font-family: Aeroport;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
}
@media (max-width: 650px) {
    .registration-button {
        gap: 5px;
        width: 169px;
        height: 54px;
    }
}
</style>